// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2175":"4417961842a33157","2888":"03b81a357fd43079","8666":"dcb88e69b17ade66"}[chunkId] + ".css";
};